import React from 'react';
import { useTranslation } from 'react-i18next';
import { getCardTypes } from '../utils/enums';

const CardTypeSelect = ({ label, selectId, required, defaultSelectedItem, setSelectedItem, showLabel = true }) => {
  const { t } = useTranslation();
  const cardTypes = getCardTypes(t);

  return (
    <div>
      {showLabel && (
        <label className="block text-sm font-medium text-gray-700 mb-1">
          {label}
          {required && <span className="text-red-500 ml-1">*</span>}
        </label>
      )}
      <select
        id={selectId}
        value={defaultSelectedItem || ''}
        onChange={(e) => {
          const selectedCardType = cardTypes.find(ct => ct.value === parseInt(e.target.value));
          setSelectedItem(selectedCardType);
        }}
        className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
        required={required}
      >
        <option value="">{t('enums.cardTypes.Select') || 'Select Card Type'}</option>
        {cardTypes.map(cardType => (
          <option key={cardType.value} value={cardType.value}>
            {cardType.label}
          </option>
        ))}
      </select>
    </div>
  );
};

export default CardTypeSelect;
